import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const Input = (props) => {
   let inputElement = null;
   switch (props.type) {
      case 'textarea':
         inputElement = <textarea {...props} />;
         break;
      case 'text':
         inputElement = <input {...props} />;
         break;
      case 'date':
         inputElement = <DatePicker {...props} />;
         break;
      case 'password':
         inputElement = <input {...props} />;
         break;
      default:
         inputElement = <input {...props} />;
         break;
   }
   return (
      <>
         {inputElement}
         {props.muted ? <small className='form-text text-muted'>{props.textMuted}</small> : ''}
      </>
   );
};

export default Input;
